export default class extends HTMLElement {
  connectedCallback () {
    this.form = this.querySelector('[data-delete-account-modal-target="form"]')
    this.phraseInput = this.querySelector('[data-delete-account-modal-target="phraseInput"]')
    this.submitBtn = this.querySelector('[data-delete-account-modal-target="submitBtn"]')
    this.errorDisplay = this.querySelector('[data-delete-account-modal-target="error"]')
    this.expectedPhrase = this.form?.dataset.confirmationPhrase

    // Handle form submission
    this.form?.addEventListener('submit', this.onSubmit)

    // Handle phrase input — enable submit when matched
    this.phraseInput?.addEventListener('input', this.onPhraseInput)

    // Wire up trigger button(s)
    document.querySelectorAll(`[data-delete-account-modal-trigger="${this.id}"]`).forEach((btn) => {
      btn.addEventListener('click', this.open)
    })

    // Wire up close button(s)
    this.querySelectorAll('[data-delete-account-modal-close]').forEach((btn) => {
      btn.addEventListener('click', this.close)
    })

    // Wire up backdrop click
    this.querySelectorAll('[data-delete-account-modal-backdrop]').forEach((el) => {
      el.addEventListener('click', this.backdropClick)
    })
  }

  disconnectedCallback () {
    this.form?.removeEventListener('submit', this.onSubmit)
    this.phraseInput?.removeEventListener('input', this.onPhraseInput)
    document.querySelectorAll(`[data-delete-account-modal-trigger="${this.id}"]`).forEach((btn) => {
      btn.removeEventListener('click', this.open)
    })
    this.querySelectorAll('[data-delete-account-modal-close]').forEach((btn) => {
      btn.removeEventListener('click', this.close)
    })
    this.querySelectorAll('[data-delete-account-modal-backdrop]').forEach((el) => {
      el.removeEventListener('click', this.backdropClick)
    })
  }

  open = () => {
    this.classList.remove(this.dataset.deleteAccountModalHiddenClass || 'hidden')
    this.phraseInput?.focus()
  }

  close = () => {
    this.classList.add(this.dataset.deleteAccountModalHiddenClass || 'hidden')
    if (this.phraseInput) {
      this.phraseInput.value = ''
    }
    this.errorDisplay?.classList.add('hidden')
    this.updateSubmitButton()
  }

  backdropClick = (e) => {
    if (this.dataset.backdropClose === 'false' || e.target?.dataset?.backdropClose === 'false') {
      return
    }
    // Only close if clicking the backdrop itself, not the modal card
    if (e.target === e.currentTarget) {
      this.close()
    }
  }

  onPhraseInput = () => {
    this.updateSubmitButton()
    this.errorDisplay?.classList.add('hidden')
  }

  updateSubmitButton () {
    if (!this.submitBtn || !this.phraseInput) return

    const matches = this.phraseInput.value.trim() === this.expectedPhrase
    this.submitBtn.disabled = !matches
    if (matches) {
      this.submitBtn.classList.remove('opacity-50', 'cursor-not-allowed')
    } else {
      this.submitBtn.classList.add('opacity-50', 'cursor-not-allowed')
    }
  }

  onSubmit = async (e) => {
    e.preventDefault()

    const form = e.target
    const formData = new FormData(form)
    const url = form.action
    const method = form.method || 'delete'

    try {
      const response = await fetch(url, {
        method,
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        },
        body: formData,
        redirect: 'manual'
      })

      if (response.status === 422) {
        const data = await response.json()
        this.showError(data.error || 'Confirmation phrase is incorrect')
        return
      }

      if (response.ok || response.redirected || response.type === 'opaqueredirect') {
        // Success — account deletion initiated, redirect to homepage
        window.location.href = '/'
        return
      }

      // Fallback: try to parse error
      const data = await response.json().catch(() => ({}))
      this.showError(data.error || 'An error occurred')
    } catch (err) {
      this.showError('An error occurred. Please try again.')
    }
  }

  showError (message) {
    if (!this.errorDisplay) return

    this.errorDisplay.textContent = message
    this.errorDisplay.classList.remove('hidden')
  }
}
